import React from 'react'

/** Legacy `/claims` route — redirects to Shipping → Claims tab. */
export default React.lazy(() => import('./ClaimsLegacyRedirect'))
